// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3hjxS","col":"styles_col__3Jmjs","fulfillmentStatus":"styles_fulfillmentStatus__2JP7Z","emailCol":"styles_emailCol__hw6RQ"};